import React, { useEffect } from "react";
import ContainerBody from "../components/ContainerBody";
import ContainerNav from "../components/ContainerNav";
import { Typography } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fab from "@mui/material/Fab";
import RawOnIcon from "@mui/icons-material/RawOn";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ContainerRoot from "../components/ContainerRoot";
import { Button, Rating, TextField } from "@mui/material";
import { PushResultsToDynamoDB } from "../utils/PushResultsToDynamoDB";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Result(props) {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(props.language);
  }, [i18n, props.language]);
  const [selectedImg, setSelectedImg] = useState(null);
  const [rating, setRating] = useState(0);
  const [openRatingDialog, setOpenRatingDialog] = useState(false);
  const [feedback, setFeedback] = useState("");
  const navigate = useNavigate();

  const images = props.result;
  const sketch = images[0];
  const results = images.slice(1);

  const downloadImages = (event) => {
    // console.log("event: ", JSON.stringify(event));
    // console.log("url: ", JSON.stringify(url));
    event.preventDefault();
    const link = document.createElement("a");
    const char =
      "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz1234567890";
    const random = Array.from(
      { length: 8 },
      () => char[Math.floor(Math.random() * char.length)]
    );
    const randomString = random.join("");
    link.download = randomString + ".jpg"; // You can customize the downloaded file name here
    link.href = selectedImg;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleImgClick = (imgSrc) => {
    console.log(imgSrc);
    setSelectedImg(imgSrc);
  };

  const handleClose = () => {
    setSelectedImg(null);
  };

  const handleSubmitRating = () => {
    setOpenRatingDialog(true);
  };

  const handleCloseRating = () => {
    setOpenRatingDialog(false);
  };

  const handleFeedbackChange = (event) => {
    setFeedback(event);
  };

  async function handleFeedbackSubmit() {
    const data_to_db = {
      guid: props.guid,
      parameters: props.parameters,
      hardPrompts: props.hardPrompts,
      prompt: props.prompt,
      rating: rating,
      feedback: feedback,
    };
    const data = await PushResultsToDynamoDB(data_to_db);
    console.log(data);
    navigate("/");
  }

  return (
    <ContainerRoot>
      <ContainerBody>
        <Typography>{t("Result")}</Typography>
        <ImageList cols={2}>
          {results.map((item) => (
            <ImageListItem key={item}>
              <img
                src={item}
                alt="result"
                loading="lazy"
                onClick={() => handleImgClick(item)}
              />
            </ImageListItem>
          ))}
        </ImageList>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            position: "absolute",
            bottom: "12vh",
            right: "1vh",
            alignItems: "space-between",
            justifyContent: "space-between",
          }}
        >
          <Fab color="secondary" aria-label="edit" style={{ margin: "1px" }}>
            <RawOnIcon onClick={() => handleImgClick(sketch)} />
          </Fab>
        </div>
        <Dialog
          open={selectedImg !== null}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <img
              src={selectedImg}
              alt="selected"
              style={{ maxWidth: "100%", maxHeight: "100vh" }}
            />
          </DialogContent>
          <DialogActions>
            <ArrowCircleDownIcon onClick={(event) => downloadImages(event)} />
            <HighlightOffIcon onClick={handleClose} />
          </DialogActions>
        </Dialog>
        <Dialog
          open={openRatingDialog}
          onClose={handleCloseRating}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Rating
              name="size-large"
              value={rating}
              size="large"
              onChange={(event, newValue) => {
                setRating(newValue);
              }}
            />
            <TextField
              placeholder={t("Please leave your comments here.")}
              size="small"
              fullWidth
              defaultValue={feedback}
              multiline
              rows={4}
              onChange={(event) => handleFeedbackChange(event.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleFeedbackSubmit}
              color="primary"
              variant="contained"
            >
              {t("Back to Start")}
            </Button>
            <Button onClick={handleCloseRating}>{t("Close")}</Button>
          </DialogActions>
        </Dialog>
      </ContainerBody>
      <ContainerNav>
        {/* TODO:  Add incoming features here */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleSubmitRating(props)}
        >
          {t("Done")}
        </Button>
      </ContainerNav>
    </ContainerRoot>
  );
}
